module.exports = __webpack_public_path__ + "img/card-cupo.8186d669.svg";